/**
 * @generated SignedSource<<5314d71cdb7d51f7bd9f6345fc47132c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type graphUtils_groupedSamples$data = {
  readonly " $fragmentSpreads": FragmentRefs<"urlParams_thirdPartyToggleDefaults">;
  readonly " $fragmentType": "graphUtils_groupedSamples";
};
export type graphUtils_groupedSamples$key = {
  readonly " $data"?: graphUtils_groupedSamples$data;
  readonly " $fragmentSpreads": FragmentRefs<"graphUtils_groupedSamples">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "graphUtils_groupedSamples",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "urlParams_thirdPartyToggleDefaults"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "de30d9cf00ef00172af86d2db3df6fce";

export default node;
